/* =========================================================
   RoyalArt — predictive-search.js
   Shopify Predictive Search API
   ========================================================= */
(function () {
  "use strict";
  var RA = (window.RoyalArt = window.RoyalArt || {});
  var routes = RA.routes || {};

  var input = document.querySelector("[data-predictive-search-input]");
  var results = document.querySelector("[data-predictive-search-results]");
  if (!input || !results) return;

  var timer, controller;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function search(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    var url = (routes.predictive || "/search/suggest") +
      ".json?q=" + encodeURIComponent(q) +
      "&resources[type]=product,collection,query&resources[limit]=6&section_id=";
    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) { render(data.resources && data.resources.results, q); })
      .catch(function () {});
  }

  function render(res, q) {
    if (!res) { results.innerHTML = ""; return; }
    var html = "";
    if (res.queries && res.queries.length) {
      html += '<div class="predictive__group"><div class="predictive__heading">Suggestions</div>';
      html += res.queries.slice(0, 4).map(function (item) {
        return '<a class="predictive__item" href="' + item.url + '">' + escapeHtml(item.text) + "</a>";
      }).join("");
      html += "</div>";
    }
    if (res.collections && res.collections.length) {
      html += '<div class="predictive__group"><div class="predictive__heading">Collections</div>';
      html += res.collections.slice(0, 4).map(function (c) {
        return '<a class="predictive__item" href="' + c.url + '">' + escapeHtml(c.title) + "</a>";
      }).join("");
      html += "</div>";
    }
    if (res.products && res.products.length) {
      html += '<div class="predictive__group"><div class="predictive__heading">Products</div>';
      html += res.products.slice(0, 6).map(function (p) {
        var img = (p.image || (p.featured_image && p.featured_image.url)) || "";
        return (
          '<a class="predictive__item" href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="" width="48" height="60" loading="lazy">' : "") +
          "<span>" + escapeHtml(p.title) + "</span></a>"
        );
      }).join("");
      html += "</div>";
    }
    if (!html) html = '<p class="ink-soft t-15">No matches for “' + escapeHtml(q) + "”.</p>";
    results.innerHTML = html;
  }

  input.addEventListener("input", function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { results.innerHTML = ""; return; }
    timer = setTimeout(function () { search(q); }, 220);
  });
})();
